





























































import { defineComponent, PropType, ref } from '@vue/composition-api';
import Toolbar from '@/components/Toolbars/Toolbar.vue';
import ContactList from '@/components/Lists/ContactList.vue';
import { Contact } from '@/graphql';
import ContactDeleteProvider from '@/providers/ContactDeleteProvider.vue';
import ContactForm from '@/components/Forms/ContactForm.vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import ContactUpsertProvider from '@/providers/ContactUpsertProvider.vue';

export default defineComponent({
  components: {
    ContactUpsertProvider,
    Tooltip,
    ContactForm,
    ContactDeleteProvider,
    ContactList,
    Toolbar,
  },
  props: {
    plannedMeasureId: {
      type: String,
      required: true,
    },
    contacts: {
      type: Array as PropType<Contact[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  setup() {
    const selected = ref<Contact | null>(null);

    return {
      selected,
      select: (contact: Contact) => {
        selected.value = contact;
      },
      unselect: () => {
        selected.value = null;
      },
      created: (contact: Contact) => {
        selected.value = contact;
      },
    };
  },
});
